import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { Values } from "Tools/Values";
import { PermissionGroup } from "@src/Interfaces/Entity/PermissionGroup";
import PermissionGroupTableItem from "./PGTableItem/PGTableItem";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";

interface IProps {
  permissionGroups: PermissionGroup[];
}

export default class PermissionGroupsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.permissionGroups.map((permissionGroup: PermissionGroup) => {
              return <PermissionGroupTableItem key={permissionGroup.id} permissionGroup={permissionGroup} />;
            })}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
